import { useEffect, useState } from 'react'

const Voting = ({ config }) => {
    const [selectedOption, setSelectedOption] = useState(null)
    const [hasVoted, setHasVoted] = useState(false)

    useEffect(() => {
        setSelectedOption(null)
        setHasVoted(false)
    }, [config])

    const handleVote = async (option) => {
        if (hasVoted) return;

        setSelectedOption(option);
        setHasVoted(true);

        try {
            // El endpoint que creamos en el backend de C# espera { zone: 'azul' u 'oro' }
            await fetch(`${process.env.REACT_APP_API_URL}Voting/Vote`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ zone: option.zoneRef }) 
            });
        } catch (error) {
            console.error("Error enviando voto", error);
        }
    }

    if (!config || !config.options) {
        return <p className="QuizzWithImageAndOptions__Title">Cargando opciones...</p>
    }

    return (
        <div className="QuizzWithImageAndOptions">
            {!hasVoted ? (
                <>
                    <p className="QuizzWithImageAndOptions__Title">{config.question}</p>

                    <div className="QuizzWithImageAndOptions__Tiles">
                        {config.options.map((option, index) => (
                            <button 
                                key={index} 
                                className="QuizzWithImageAndOptions__Tiles__Buttons Btn__Adsl--RedOutline mb-3" 
                                onClick={() => handleVote(option)}
                            >
                                <span className='QuizzWithImageAndOptions__Tiles__Buttons__Text'>{option.text}</span>
                            </button>
                        ))}
                    </div>
                </>
            ) : (
                <div className="text-center mt-4">
                    <p className="QuizzWithImageAndOptions__Title mb-4">Tú elegiste...</p>
                    <div className="QuizzWithImageAndOptions__Tiles__Buttons" style={{ opacity: 1 }}>
                        <span className='QuizzWithImageAndOptions__Tiles__Buttons__Text'>{selectedOption?.text}</span>
                    </div>
                    <p className="small opacity-75 mt-5">Mira la pantalla del estadio para ver los resultados de la votación</p>
                </div>
            )}
        </div>
    )
}

export { Voting };